import React , {useState} from "react";


const CategoryCard = () => {
  const categoryData = [
    {
      img: "/image/bids/img-1.jpg",
      logo1: "/image/category/logo-3.png",
      logo2: "/image/category/logo-4.png",
      like: 14,
      title: "Flourishing Cat #180",
      content: "From 8.49 ETH2/8",
      category: 'one',

    },
    {
      img: "/image/bids/img-2.jpg",
      logo1: "/image/category/logo-1.png",
      logo2: "/image/category/logo-6.png",
      like: 20,
      title: "Amazing NFT Art",
      content: "From 5.9 ETH1/7",
      category: 'two',
    },
    {
      img: "/image/bids/img-3.jpg",
      logo1: "/image/category/logo-3.png",
      logo2: "/image/category/logo-4.png",
      like: 14,
      title: "SwagFox#133",
      content: "0.078 ETH1/3",
      category: 'one',
    },
    {
      img: "/image/bids/img-4.jpg",
      logo1: "/image/category/logo-5.png",
      logo2: "/image/category/logo-6.png",
      like: 9,
      title: "Splendid Girl",
      content: "10 ETH2/3",
      category: 'three',
    },
    {
      img: "/image/category/img-7.jpg",
      logo1: "/image/category/logo-1.png",
      logo2: "/image/category/logo-1.png",
      like: 14,
      title: "Monkeyme#155",
      content: "From 5 FLOW1/1",
      category: 'one',
    },
    {
      img: "/image/category/img-8.jpg",
      logo1: "/image/category/logo-3.png",
      logo2: "/image/category/logo-4.png",
      like: 28,
      title: "Jedidia#149",
      content: "0.16 ETH1/1",
      category: 'two',
    },
    {
      img: "/image/category/img-9.jpg",
      logo1: "/image/category/logo-5.png",
      logo2: "/image/category/logo-6.png",
      like: 18,
      title: "Artof Eve",
      content: "0.13 FLOW1/1",
      category: 'three',
    },
    {
      img: "/image/category/img-10.jpg",
      logo1: "/image/category/logo-1.png",
      logo2: "/image/category/logo-2.png",
      like: 12,
      title: "Asuna#1649",
      content: "0.8 ETH1/1",
      category: 'two',
    },
  ];
  const [filterData , setFilterData] = useState([...categoryData]);

  const filterCategory = (value) => {
    const filterItem = categoryData.filter(element => {
      return   element.category === value;
    })
    return setFilterData(filterItem)
  };


  return (
    <div className="category-section section-padding ">
      <div className="container">
        <div className="category-title d-flex align-items-center justify-content-center gap-3 text-white" data-aos='zoom-in' >
          <img
            src="/image/category/title-logo.png"
            alt=""
            style={{ width: "2.5rem ", height: "2.5rem" }}
          />
          <h2 className="">Trending Categories</h2>
        </div>

        {/* FILTER BUTTONS */}

        <div className="row g-4 d-flex align-items-center justify-content-lg-between justify-content-center mt-5">
          <div className="col-lg-10" data-aos='zoom-in' >
            <div className="filter-buttons d-flex flex-wrap justify-content-lg-start justify-content-center gap-3" >
              <button type="button" className="active" onClick={() => setFilterData(categoryData)}>
                All
              </button>
              <button type="button" onClick={() => filterCategory('three')}>
                Art
              </button>
              <button type="button" onClick={() => filterCategory('one')}>
                Collection
              </button>
              <button type="button" onClick={() => filterCategory("two")}>
                Domain
              </button>
              <button type="button" onClick={() => filterCategory('one')}>
                Music
              </button>
              <button type="button" onClick={() => filterCategory('two')}>
                Photography
              </button>
              <button type="button" onClick={() => filterCategory('three')}>
                Virtual World
              </button>
            </div>
          </div>
          <div className="col-lg-2  d-flex justify-content-lg-end justify-content-center align-items-center " data-aos='zoom-out' >
            <div className="dropdown d-lg-block d-none">
              <button
                className=" dropdown-btn dropdown-toggle"
                type="button"
                id="dropdownMenu2"
                data-bs-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                Past 7 Days
              </button>
              <div
                className="dropdown-menu shadow "
                aria-labelledby="dropdownMenu2"
              >
                <button className="dropdown-item" type="button" onClick={ () => filterCategory('three')}>
                  Past 24 Hours
                </button>
                <button className="dropdown-item" type="button" onClick={ () => filterCategory('one')} >
                  Past 7 Days
                </button>
                <button className="dropdown-item" type="button" onClick={ () => setFilterData(categoryData)} >
                  Past 30 Days
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* FILTER CARD SECTION */}
        <div className="row mt-md-5 mt-4 g-4">
          {filterData.map((element, index) => {
            return (
              <div key={index} className="col-lg-3 col-sm-6" data-aos='fade-up' >
                <div className="bid-card">
                  <div className="position-relative">
                    <p className="fw-normal mb-0 like d-flex align-items-center gap-3">
                      <i className="fa fa-heart"></i> {element.like}
                    </p>
                    <img src={element.img} className="main-img" style={{objectFit: 'cover'}} alt="" />
                    <div className="bid-logo">
                        <img src={element.logo1} alt="" />
                        <img src={element.logo2} alt="" />
                    </div>
                  </div>
                  <div className="bid-card-content mt-md-5 mt-4">
                    <div className="d-flex align-items-center justify-content-between">
                      <h4 className=" text-white">{element.title}</h4>
                    </div>
                    <p className="mt-3  mb-4">{element.content}</p>
                    <div className="w-100 d-flex align-items-center justify-content-between">
                      <a href="#" className="bid-btn">Buy Now</a>
                      <a href="#" className="fs-4 text-decoration-none history-btn "> <i className="fa fa-history d-inline-block me-2"></i> View history</a>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default CategoryCard;
